import { http } from 'services'
// initial state
const state = () => ({
  all: [],
  active: {},
  errors: null
})

// getters
const getters = {
}

// actions
const actions = {
  ['poi.getAll'] ({ commit }, params) {
    if (!params._q) params._q = null

    commit('CLEAR_ERRORS')

    return (http.get('point-of-interest', {
      params
    })).then ((res) => {
      commit('GET_ALL_POI', res);
    })
    .catch ((res) => {
      commit('POI_ERROR', res);
    })
  },
  ['poi.newPOI'] ({ commit }, data) {
    commit('CLEAR_ERRORS')

    return (http.post('point-of-interest', data))
    .then ((res) => {
    })
    .catch ((res) => {
      commit('POI_ERROR', res);
    })
  },
  ['poi.editPOI'] ({ commit }, {id, data}) {
    commit('CLEAR_ERRORS')
    return (http.put('point-of-interest/' + id , data))
    .then ((res) => {
      commit('EDIT_VENDOR', res);
    })
    .catch ((res) => {
      commit('POI_ERROR', res);
    })
  },
  ['poi.removePOI'] ({ commit }, id) {
    commit('CLEAR_ERRORS')

    return (http.delete('point-of-interest/' + id))
    .then ((res) => {
      commit('REMOVE_VENDOR', id);
    })
    .catch ((res) => {
      commit('POI_ERROR', res);
    })
  },
  ['poi.getPOI'] ({ dispatch, commit, state }, id) {
    commit('CLEAR_ERRORS')
    return dispatch('roles.getAll', {_all: true}).then(() => {
      return (http.get('point-of-interest/' + id))
      .then ((res) => {
        commit('GET_VENDOR', res);
      })
      .catch ((res) => {
        commit('POI_ERROR', res);
      })
    })
  },
}

// mutations
const mutations = {
  GET_ALL_POI (state, res) {

    state.all = res.data;
  },

  GET_VENDOR (state, res) {
    state.active = res.data
  },

  REMOVE_VENDOR (state, id) {
    state.all.data = _.filter(state.all.data, (item) => item.id != id);
  },

  EDIT_VENDOR (state, res) {
    state.active = res.data
  },

  //ERRORS
  POI_ERROR (state, err) {
    try {
      state.errors = err.response.data;
    } catch (e) {
      state.errors = err;
    }
  },

  CLEAR_ERRORS (state) {
    state.errors = null
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
